// extracted by mini-css-extract-plugin
export default {"wixFee":"n+EBo"};